import actions from "./actions";

const initState = {
  users: null,
  user: null,
  roles: null,
  schools: null,
  courses: null,
  organizations: null,
  grades: null,
  subjects: null,
  key: null,
  teachers: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_USERS_ADMIN_SUCCESS:
      return {
        ...state,
        users: action.users,
      };

    case actions.FETCH_USER_ADMIN_DETAILS_SUCCESS:
    case actions.FETCH_USER_ADMIN_DETAILS_FAIL:
      return {
        ...state,
        user: action.user,
      };

    case actions.CHANGE_ADMIN_STATUS_SUCCESS: {
      if (!state.users) return state;
      // Make a shallow copy of users array
      const users = [...state.users];
      const userIndex = users.findIndex((user) => user._id === action.userId);
      if (userIndex > -1) {
        // Copy the user object and update isActive
        users[userIndex] = {
          ...users[userIndex],
          isActive: action.isActive,
        };
      }
      return {
        ...state,
        users,
      };
    }

    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };

    case actions.RESET:
      return {
        ...state,
        // users: null, // commented out in original code
        user: null,
      };

    case actions.FETCH_ORGANIZATION_SCHOOL_SUCCESS:
      return {
        ...state,
        schools: action.schools,
      };

    case actions.FETCH_ORGANIZATION_COURSE_SUCCESS:
      return {
        ...state,
        courses: action.courses,
      };

    case actions.FETCH_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organizations: action.organizations,
      };

    case actions.FETCH_TEACHER_SUCCESS:
      return {
        ...state,
        teachers: action.teachers,
      };

    default:
      return state;
  }
}
